import { ProjectSchema, SCHEMA_VERSION, type Project } from './schema.ts';

type Migration = (doc: Record<string, unknown>) => Record<string, unknown>;

/** `MIGRATIONS[n]` upgrades a document from schema version `n` to `n + 1`. */
const MIGRATIONS: Record<number, Migration> = {
  // Add `n: (doc) => upgradedDoc` here when SCHEMA_VERSION is bumped from n to n + 1.
  /** v3: library folders. */
  2: (doc) => ({ ...doc, mediaFolders: {} }),
  /** v4: linear-light blending; older projects keep the gamma-space blending they were made with. */
  3: (doc) => ({ ...doc, settings: { ...(doc.settings as Record<string, unknown>), blending: 'srgb' } }),
};

/**
 * Upgrades a persisted document to the current schema version and validates it.
 * Throws a descriptive error for documents that cannot be read.
 */
export function migrateProject(raw: unknown): Project {
  if (typeof raw !== 'object' || raw === null) throw new Error('Project file is not an object');
  let doc = raw as Record<string, unknown>;
  let version = typeof doc.schemaVersion === 'number' ? doc.schemaVersion : 0;
  if (version > SCHEMA_VERSION) {
    throw new Error(`Project was saved by a newer version (schema ${version}); please update the editor`);
  }
  while (version < SCHEMA_VERSION) {
    const step = MIGRATIONS[version];
    if (!step) throw new Error(`No migration from schema version ${version}`);
    doc = { ...step(doc), schemaVersion: version + 1 };
    version++;
  }
  return ProjectSchema.parse(doc);
}
